import { DatePicker } from '@/components/form/inputs/date-picker';
import { UpdateTask } from '@/task-manager/api/mutations/update-task';
import type { TaskDetails } from '@/task-manager/entities/task-details';

import { TaskAttribute } from '../task-attribute';

export type TaskDateProps = {
  label: string;
  task: TaskDetails;
};

export function TaskDate({ label, task }: TaskDateProps) {
  const updateTask = UpdateTask.useMutation();

  return (
    <TaskAttribute label={label}>
      <DatePicker
        value={task.dueAt}
        onSelect={function (dueAt) {
          updateTask.mutate({ id: task.id, dueAt: dueAt ?? null });
        }}
        loading={updateTask.isLoading}
        clearable
      />
    </TaskAttribute>
  );
}
